import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-white py-20 md:py-24" data-id="element-225" data-mp="2lstl5l3i8ih6">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-5 md:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-226" data-mp="2lu4pbm0v3s8t">
        <div data-id="element-227" data-mp="30iis5wya3gpd">
          <h2 className="font-display text-3xl font-bold leading-tight text-forest md:text-5xl" data-id="element-228" data-mp="30j0vten9sx7b">
            Tired of contractors who don’t show up?
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-229" data-mp="39gb54ugj2c9l">
            Cracked concrete, overgrown beds, dead spots in the lawn — and every quote is either too high or never
            comes.
          </p>
        </div>

        <figure className="border-l-4 border-brick bg-brick/[0.05] p-7 md:p-8" data-id="element-230" data-mp="3jdpmqxe6t73h">
          <QuoteIcon className="mb-3 h-6 w-6 text-brick" aria-hidden="true" data-id="element-231" data-mp="3ehs2wh3ptily" />
          <blockquote className="font-display text-xl leading-relaxed text-[#7f1d1d] md:text-2xl" data-id="element-232" data-mp="1p2u2uyxjy5le">
            One quoted $8,000 for a $3,500 job. The next left a mess. The third said “Tuesday” and never showed.
          </blockquote>
        </figure>
      </div>

      <p className="mx-auto mt-14 max-w-3xl px-5 text-center font-display text-2xl font-bold text-forest md:px-8 md:text-3xl" data-id="element-233" data-mp="obyd08seoyki">
        Dany shows up, does it right, and stands behind it.
      </p>
    </section>;
}